import { render, staticRenderFns } from "./ContentToPrint.vue?vue&type=template&id=13cd2dff&scoped=true"
import script from "./ContentToPrint.vue?vue&type=script&lang=js"
export * from "./ContentToPrint.vue?vue&type=script&lang=js"
import style0 from "./ContentToPrint.vue?vue&type=style&index=0&id=13cd2dff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd2dff",
  null
  
)

export default component.exports